import React, { useState } from 'react';
import { styled } from '@mui/material';
import { Colors, Text, TextButton } from 'library';
import { ChevronRightRounded } from '@mui/icons-material';
import { AddPaymentMethodModal } from 'shared/payments';

import { Link } from 'react-router-dom';

export function PaymentSetupRow({ status, refresh }: { status: string; refresh: () => void }) {
    const [openConnectPayment, setOpenConnectPayment] = useState<boolean>(false);

    if (status === 'needs_verified') {
        return (
            <Row to="/payments">
                <Body>
                    <Header>
                        <Text variant="h2" bold>
                            Complete your Payment Setup
                        </Text>
                        <Text
                            variant="caption"
                            bold
                            textStyle={{
                                backgroundColor: Colors.error,
                                color: Colors.white,
                                padding: '0px 10px',
                                borderRadius: 20,
                            }}
                        >
                            Required
                        </Text>
                    </Header>
                    <Text variant="caption">Verify your account to complete payment setup.</Text>
                </Body>
                <ChevronRightRounded htmlColor={Colors.darkNavy} style={{ height: 36, width: 36 }} />
            </Row>
        );
    }

    if (status === 'needs_payment' || status === 'need_setup') {
        return (
            <>
                <ModalRow>
                    <Body>
                        <Header>
                            <TextButton
                                onClick={() => setOpenConnectPayment(true)}
                                buttonStyle={{ width: 'fit-content' }}
                            >
                                <Text variant="h2" bold>
                                    Add a Payment Method
                                </Text>
                            </TextButton>
                            <Text
                                variant="caption"
                                bold
                                textStyle={{
                                    backgroundColor: Colors.error,
                                    color: Colors.white,
                                    padding: '0px 10px',
                                    borderRadius: 20,
                                }}
                            >
                                Required
                            </Text>
                        </Header>
                        <Text variant="caption">Set up a primary payment method on your account.</Text>
                        <InvoiceLink
                            href="https://chatwoot.join-tandem.com/hc/child-care-center-help-center/en/categories/payments"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Learn more about the invoicing process.
                        </InvoiceLink>
                    </Body>
                    <BlankButton onClick={() => setOpenConnectPayment(true)}>
                        <ChevronRightRounded htmlColor={Colors.darkNavy} style={{ height: 36, width: 36 }} />
                    </BlankButton>
                </ModalRow>
                <AddPaymentMethodModal
                    open={openConnectPayment}
                    onClose={() => setOpenConnectPayment(false)}
                    onSuccess={refresh}
                />
            </>
        );
    }

    return null;
}

const Header = styled('div')({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
});

const Body = styled('div')({
    height: '100%',
    width: '100%',
});

const Row = styled(Link)({
    alignItems: 'center',
    backgroundColor: Colors.lightRed,
    borderRadius: 10,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    marginBottom: 5,
    padding: 15,
    width: '100%',
    '&:hover': {
        backgroundColor: Colors.lightGrey,
    },
});

const ModalRow = styled('div')({
    alignItems: 'center',
    backgroundColor: Colors.lightRed,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    marginBottom: 5,
    padding: 15,
    width: '100%',
});

const InvoiceLink = styled('a')({
    color: Colors.darkNavy,
    textDecoration: 'underline',
});

const BlankButton = styled('button')({
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    cursor: 'pointer',
    '&:focus': {
        border: 'none',
        outline: 'none',
    },
    '&:active': {
        border: 'none',
        outline: 'none',
    },
});
